<template>
    <div v-if="!delayInProgress" :class="['tripDelayButtonDiv', thisDelayResolved ? 'resolved' : '']" v-on="!thisDelayResolved ? { click: selectDelay } : {}"> <!-- @click="setTripStatus">-->
        <i v-if="thisDelayResolved" class='fa fa-check-square-o'></i>
        <i v-else class='fa fa-square-o'></i>
         <div>
            {{ delayDisplay }}
        </div> 
    </div>
    <div v-else-if="thisDelaySelected" class="delayInProgressDiv">
        <div id="inProgressDelayDisplay">
            {{ delayDisplay }}
        </div>
        <div class="delayResolutions">
            <div class="resolveDelay" @click="resolveDelay">
                Complete
            </div>
            <div class="cancleDelay" @click="cancleDelay">
                Cancel
            </diV>
        </div>
    </div>
</template>

<script>
    import epoch from 'epoch.js';

    export default {
        props: [
            'tripId',
            'delay'
        ],
        computed: {
            trip() {
                return this.$privateReactiveStore.getTrip(this.tripId);
            },
            delayInProgress() {
                return this.trip.transit_delay_id != null;
            },
            thisDelaySelected() {
                return this.delay.id == this.trip.transit_delay_id;
            },
            delayDisplay() {
                return this.thisDelayResolved ? this.delay.delay_resolved_text : this.delay.delay_text;
            },
            thisDelayResolved() {
                let tripDelaysResolved = this.trip.transit_delays_resolved ? this.trip.transit_delays_resolved.split(',') : [];
                
                return Array.isArray(tripDelaysResolved) ? tripDelaysResolved.indexOf(this.delay.id.toString()) > -1 : this.delay.id == this.trip.transit_delays_resolved;
            }
        },
        methods: {
            selectDelay() {
                let now = epoch().datetime();
                let tripDelayUpdate = {transit_delay_id: this.delay.id, transit_delay_time: now};

                this.$eventHub.$emit('updateTrip', this.trip.id, tripDelayUpdate);
            },
            cancleDelay() {
                this.$eventHub.$emit('cancleDelay');
            },
            resolveDelay() {
                let now = epoch().datetime();
                let tripDelayUpdate = {transit_delay_id: null, transit_delay_time: now, transit_delays_resolved: this.delay.id};

                this.$eventHub.$emit('updateTrip', this.trip.id, tripDelayUpdate);
                this.$eventHub.$emit('completeDelay');
            },
        }
    }
</script>

<style scoped>
    .tripDelayButtonDiv {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        border-radius: 1vw;
        padding: 1.25vh 0;
        margin: .4vh 0;
        background-color: #faf170;
        border-top: solid thick #ffee05;
        border-left: solid thick #ffee05;
        border-right: solid thick #a19605;
        border-bottom: solid thick #a19605;
        font-style: normal;
        font-weight: bold;
        cursor: pointer;
    }

    .tripDelayButtonDiv.resolved {
        border: none;
        background-color: inherit;
    }

    .delayInProgressDiv {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #inProgressDelayDisplay {
        height: 15vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bolder;
        font-size: 1.2em;
    }

    .delayResolutions {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: space-evenly;
    }

    .resolveDelay {
        display: flex;
        width: 60%;
        align-items: center;
        justify-content: center;
        border-radius: 1vw;
        padding: 1.25vh 0;
        margin: .4vh 0;
        background-color: #07fc03;
        border-top: solid thick #9efc9d;/*#75f573;*/
        border-left: solid thick #9efc9d;/*#479645;*/
        border-right: solid thick #049c02;
        border-bottom: solid thick #025201;
        font-style: normal;
        font-weight: bold;
    }

    .cancleDelay {
        display: flex;
        justify-content: center;
        align-items: center;
        color: blue;
        font-weight: bold;
        text-decoration: underline;
        width: 40%
    }

    .resolved {
        background-color: none;
        border: none;
    }

    .tripDelayButtonDiv div {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-style: italic;
    }

    .tripDelayButtonDiv i {
        width: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2em;
    }
</style>